import "./withdrawConfirmDialog.css";
import * as AlertDialog from "@radix-ui/react-alert-dialog";

const WithdrawConfirmDialog = ({ open, onCancel, onConfirm, isDarkMode }) => {
  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="radix-overlay" />
        <AlertDialog.Content
          className={`radix-content ${isDarkMode ? "radix-dark" : ""}`}
        >
          <AlertDialog.Title className="radix-title text-white">
            Confirm Withdrawal
          </AlertDialog.Title>

          <AlertDialog.Description className="radix-description text-muter-lavender-purple">
            <p>
              Please make sure you complete the withdrawal process after
              proceeding.
            </p>
            <p>
              If the withdrawal is interrupted or not completed, your item will
              be moved to <b>Pending</b> status and reviewed manually within 3–5
              working days.
            </p>
            <p className="mt-2">Do you want to continue?</p>
          </AlertDialog.Description>

          <div className="radix-actions">
            <AlertDialog.Cancel asChild>
              <button
                className={
                  isDarkMode
                    ? "deep-primary-monochrome-btn-dark"
                    : "outlined-medium-deep-purple-btn"
                }
                onClick={onCancel}
              >
                Cancel
              </button>
            </AlertDialog.Cancel>

            <AlertDialog.Action asChild>
              <button
                className={
                  isDarkMode
                    ? "filled-medium-deep-yellow-btn-dark"
                    : "filled-medium-deep-purple-btn"
                }
                onClick={onConfirm}
              >
                Confirm
              </button>
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};

export default WithdrawConfirmDialog;
